module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "mdl-grid adv-content",
    staticStyle: {
      "display": "block",
      "background-color": "white",
      "margin-top": "20px"
    },
    attrs: {
      "id": "page-play"
    }
  }, [(_vm.adventure) ? _c('h4', {
    staticStyle: {
      "float": "left",
      "display": "inline-block",
      "text-align": "left",
      "text-overflow": "ellipsis",
      "width": "calc(100% - 200px)"
    }
  }, [_vm._v(_vm._s(_vm.textTools.parseTitle(_vm.adventure.name, "Adventure")) + " "), _c('small', [_vm._v("by "), (_vm.adventure.owner) ? _c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v(_vm._s(_vm.adventure.owner.name))]) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), (!_vm.adventure.published) ? _c('router-link', {
    staticClass: "mdl-button mdl-button--raised  mdl-button--colored mdl-js-button mdl-js-ripple-effect",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "to": ('/editor/' + _vm.adventureId + '/chapters')
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("edit")]), _vm._v(" Keep Editing")]) : _vm._e(), _vm._v(" "), _c('div', {
    class: _vm.usingObj && 'using-object',
    attrs: {
      "id": "playerContainer"
    }
  }, [(_vm.usingObj) ? _c('div', {
    style: ('top:-1000px; height: ' + _vm.dimTools.dimFullToView(100, 'player') + 'px; ' +
      'width: ' + _vm.dimTools.dimFullToView(100, 'player') + 'px;' +
      'borderRadius: ' + _vm.dimTools.dimFullToView(50, 'player') + 'px;' +
      'padding: ' + _vm.dimTools.dimFullToView(30, 'player') + 'px;' +
      'background-image: url(' + _vm.usingObjBg + ');'),
    attrs: {
      "id": "usingObjDrag"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    style: ('background-image: url(' + _vm.getStageBg() + ')'),
    attrs: {
      "id": "player"
    }
  }, [(!_vm.adventure.chapters || _vm.adventure.chapters.length <= 0) ? _c('div', [_c('h2', [_vm._v(" NO CHAPTERS FOUND IN THIS ADVENTURE ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    class: _vm.getShowTitles(_vm.showTitles),
    attrs: {
      "id": "playerTitles"
    }
  }, [_c('pre', [_vm._v(_vm._s(_vm.titlesText))])]), _vm._v(" "), _c('div', {
    class: _vm.getShowConsole(_vm.showConsole),
    attrs: {
      "id": "playerConsole"
    }
  }, [_c('pre', [_vm._v(_vm._s(_vm.consoleText))])]), _vm._v(" "), _vm._l((_vm.getInstances(_vm.instanceRefresh)), function(instance, instanceKey) {
    return _c('div', {
      style: ('transform: translate(' + _vm.dimTools.dimFullToView(instance.left, 'player') + 'px, ' + _vm.dimTools.dimFullToView(instance.top, 'player') + 'px);' +
        ' height:' + _vm.dimTools.dimFullToView(instance.height, 'player') + 'px; width:' + _vm.dimTools.dimFullToView(instance.width, 'player') + 'px; background-image: url(' + instance.bg + '); background-repeat: no-repeat; background-size: contain;  background-position: center; position: absolute;'),
      attrs: {
        "name": instanceKey
      },
      on: {
        "click": _vm.handleObject
      }
    })
  }), _vm._v(" "), _c('div', {
    class: _vm.getShowInventory(_vm.showInventory),
    style: ('position: absolute; bottom: ' + _vm.dimTools.dimFullToView(-180, 'player') + 'px; height: ' + _vm.dimTools.dimFullToView(190, 'player') + 'px; '),
    attrs: {
      "id": "inventory"
    }
  }, _vm._l((_vm.save.inventory), function(object, objectKey) {
    return _c('div', {
      class: 'mdl-cell inventory-object ' + _vm.getUsingObject(objectKey, _vm.usingObj),
      style: ('height: ' + _vm.dimTools.dimFullToView(160, 'player') + 'px; ' +
        'width: ' + _vm.dimTools.dimFullToView(160, 'player') + 'px;' +
        'padding: ' + _vm.dimTools.dimFullToView(14, 'player') + 'px;' +
        'border-radius: ' + _vm.dimTools.dimFullToView(8, 'player') + 'px;' +
        'margin: ' + _vm.dimTools.dimFullToView(12, 'player') + 'px; margin-right: 0px;'),
      attrs: {
        "name": objectKey
      },
      on: {
        "click": _vm.handleInventoryObject
      }
    }, [_c('div', {
      staticClass: "bg",
      style: ('background-image: url(' + object.bg + ')')
    }), _vm._v(" "), _c('div', {
      staticClass: "object-name"
    }, [_c('pre', [_vm._v(_vm._s(object.name))])])])
  }))], 2)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "50px",
      "text-align": "center",
      "margin-top": "10px"
    }
  }, [_c('button', {
    staticClass: "mdl-button mdl-button--raised mdl-js-button mdl-js-ripple-effect",
    staticStyle: {
      "margin-right": "6px"
    },
    on: {
      "click": _vm.restartGame
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("autorenew")]), _vm._v(" Restart Game")]), _vm._v(" "), _c('button', {
    staticClass: "mdl-button mdl-button--raised mdl-js-button mdl-js-ripple-effect",
    on: {
      "click": _vm.toggleFullscreen
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("fullscreen")]), _vm._v(" Fullscreen")])]), _vm._v(" "), _c('span', {
    staticClass: "mdl-cell--hide-desktop",
    staticStyle: {
      "font-size": "0.8em",
      "color": "#999"
    }
  }, [_vm._v("Swipe up/down to show/hide the inventory")]), _vm._v(" "), _c('span', {
    staticClass: "mdl-cell--hide-phone mdl-cell--hide-tablet",
    staticStyle: {
      "font-size": "0.8em",
      "color": "#999"
    }
  }, [_vm._v("Drag the mouse here to show the inventory")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-451e6ae5!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SectionPlay.vue
// module id = 305
// module chunks = 0